import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLangTrIconmin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18Z",
			fill: "#D80027"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m12.794 9.424.844-1.085-1.3.366-.761-1.201-.06 1.433-1.269.357 1.233.488-.06 1.407.852-1.094 1.262.499-.741-1.17Z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.677 12.08A2.964 2.964 0 0 1 5.78 9.052a2.964 2.964 0 0 1 2.897-3.028A2.475 2.475 0 0 1 11.05 7.39a3.185 3.185 0 0 0-3.128-2.108A3.641 3.641 0 0 0 4.36 9a3.64 3.64 0 0 0 3.56 3.718 2.865 2.865 0 0 0 2.794-1.561 2.143 2.143 0 0 1-2.038.923Z",
			fill: "#fff"
		})
	]
});
const ForwardRef = forwardRef(SvgLangTrIconmin);
export { ForwardRef as ReactComponent };
